import Events from 'src/pages/Events'
import { combineFallbacks, useEvents } from 'src/state'

export const EventsPage = Events

export const getStaticProps = async () => {
  const fallback = await combineFallbacks(useEvents.getFallback({}))

  return {
    props: { fallback },
    revalidate: 10 * 60,
  }
}

export default EventsPage
